(ns frontend.ui.component.lp-portal.card.view
  (:require
   [frontend.ui.component.lp-portal.card.style :as style]
   [herb.core :refer [<class]]
   [reagent.core :as r]
   [common.util :as cu]
   [frontend.ui.style.theme.core :as theme]))

(defn- simple-body
  [{:keys [id no-padding] :as props} child]
  [:div
   {:class (<class style/simple-body props)
    :id    id}
   child])

(defn- split-body
  [main-child secondary-child split-left split-right]
  [:div {:class (<class style/children-row)}
   [:div {:class (<class (partial style/main-child split-left))}
    main-child]
   [:div {:class (<class (partial style/secondary-child split-right))}
    secondary-child]])

(defn card
  [{:keys [title left-split right-split] :as props} child right-child]
  [:div
   {:class (<class (partial style/card (cu/blank-value? title)))}
   ;(when title
   [:div
    {:class (<class style/title)}
    title]
   ;)
   (if right-child
     [split-body child right-child (or left-split 8)
      (or right-split
          (when left-split
            (- 12 left-split))
          4)]
     [simple-body props child])])

(defn expandable-card
  []
  (let [expanded (r/atom false)]
    (fn [{:keys [title removed-since-empty?] :as props} child]
      [:div
       {:style (if @expanded
                 {:padding          "24px"
                  :position         "fixed"
                  :left             0
                  :top              0
                  :right            0
                  :bottom           0
                  :z-index          100000
                  :background-color (if removed-since-empty?
                                      (theme/color [:palette :danger])
                                      (theme/color [:page-bg :bg]))
                  :overflow         "auto"}
                 {:position         "relative"
                  :background-color (if removed-since-empty?
                                      (theme/color [:palette :danger])
                                      "inherit")})}
       [card
        {:title title
         :background-color (when removed-since-empty?
                             (theme/color [:palette :danger]))}
        [:div
         {:style (merge {:display :flex
                         :flex-direction :column
                         :gap "1rem"
                         :background-color "inherit"}
                        (when removed-since-empty?
                          {:background-color (theme/color [:palette :danger])}))}
         [:div
          {:style    {:position "absolute"
                      :top      "20px"
                      :right    "32px"
                      :cursor   "pointer"}
           :on-click (fn [exp]
                       (reset! expanded (not @expanded))
                       (deref expanded))}
          (if @expanded
            [:span "Collapse " [:i.fal.fa-compress-arrows-alt]]
            [:span "Expand " [:i.fal.fa-expand-arrows-alt]])]
         child]]])))
